import { Howl } from "howler"
import { Paths } from "../defines/values"

export class MusicPlayer {
  private _audio: Howl
  private _timeoutID: number = 0

  constructor(
    sourceFile: string,
    firstScreen: boolean,
    autoplay: boolean,
    volume: number,
    muted: boolean
  ) {
    const url = Paths.MUSIC + sourceFile

    this._audio = new Howl({
      src: [url],
      autoplay: autoplay,
      loop: false,
      volume: volume,
      onplay: () => {
        window.engine.showPauseButton()
        const fadeouttime = 2000
        this._timeoutID = window.setTimeout(() => {
          const fadeouttime = 2000
          this._audio.fade(this._audio.volume(), 0, fadeouttime)
        }, (this._audio.duration() - this._audio.seek()) * 1000 - fadeouttime)
      },
      onend: () => {
        window.clearTimeout(this._timeoutID)
        this._audio.volume(window.engine.getMusicVolume())
        this._audio.fade(0, this._audio.volume(), 2000)
        this.play()
      },
      onload: () => {
        window.engine.audioReady(firstScreen)
      },
      onloaderror: () => {
        console.log("[ERROR] MusicPlayer failed to load: " + url)
      },
      onplayerror: () => {
        window.engine.showPlayButton()
      },
    })

    if (muted) {
      this._audio.mute()
    }
  }

  mute(): void {
    this._audio.mute(true)
  }

  unmute(): void {
    this._audio.mute(false)
  }

  pause(): void {
    this._audio.pause()
  }

  play(): void {
    this._audio.play()
  }

  setVolume(volume: number): void {
    this._audio.volume(volume)
  }

  stop(): void {
    clearTimeout(this._timeoutID)
    this._audio.fade(this._audio.volume(), 0, 500)
    this._audio.seek(0)
    this._audio.stop()
  }

  unload(): void {
    clearTimeout(this._timeoutID)
    this._audio.unload()
  }
}
